import React, {useEffect} from "react";
import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {getTableColumns, getTableData} from "../../models/employeeModel"; // Updated model path
import Table from "../../components/common/table/Table";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {
    deleteEmployee,
    fetchEmployees,
    resetCreateStatus,
    resetEmployeeAssignStatus,
    resetUpdateStatus
} from "../../store/employee-slice";
import {useSearchParams} from "react-router-dom"; // Updated actions

const EmployeeView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        assignEmployeeStatus,
        pagination,
        error
    } = useSelector(state => state.employee); // Updated selector

    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchEmployees({
            ...userRole,
            page: initialPage,
            limit: initialLimit
        }));
    }, [dispatch, userRole, initialPage, initialLimit]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    useEffect(() => {
        if (assignEmployeeStatus === "success") {
            dispatch(resetEmployeeAssignStatus());
        }
    }, [dispatch, assignEmployeeStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteEmployee(id)); // Updated action
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="All Employees">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />
            )}
        </>
    );
};

export default EmployeeView;
